import React, {ComponentType, createContext, useContext, useState} from 'react';
import {ICashierPaymentsApi} from '@wix/cashier-payments-widget';
import {type PaymentMethodInfo} from '@wix/cashier-payments-widget/src/types/PaymentMethodInfo';

export type PaymentsApiContextType = {
  paymentsApi?: ICashierPaymentsApi;
  setPaymentsApi?: (paymentsApi: ICashierPaymentsApi) => void;
  activePaymentId?: string;
  activeSitePaymentMethodTypeId?: string;
  setActivePaymentId: (activePaymentId: string, paymentMethodInfo: PaymentMethodInfo) => void;
};

export const PaymentsApiContext = createContext({} as PaymentsApiContextType);

export function withPaymentsApi<T extends object>(Component: ComponentType<T>) {
  return function Wrapper(props: T) {
    const [paymentsApi, setPaymentsApi] = useState<ICashierPaymentsApi>();
    const [activePaymentId, setActivePaymentIdState] = useState<string>();
    const [activeSitePaymentMethodTypeId, setActiveSitePaymentMethodTypeId] = useState<string>();
    const setActivePaymentId = (paymentId: string, paymentMethodInfo: PaymentMethodInfo) => {
      setActivePaymentIdState(paymentId);
      setActiveSitePaymentMethodTypeId(paymentMethodInfo?.paymentMethodTypeId);
    };
    return (
      <PaymentsApiContext.Provider
        value={{
          paymentsApi,
          setPaymentsApi,
          activePaymentId,
          activeSitePaymentMethodTypeId,
          setActivePaymentId,
        }}>
        <Component {...props} />
      </PaymentsApiContext.Provider>
    );
  };
}

export function usePaymentsApi() {
  const {paymentsApi, setPaymentsApi, activePaymentId, activeSitePaymentMethodTypeId, setActivePaymentId} =
    useContext(PaymentsApiContext);
  return {paymentsApi, setPaymentsApi, activePaymentId, activeSitePaymentMethodTypeId, setActivePaymentId};
}
